import React, { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress, Container, makeStyles, Typography } from '@material-ui/core';
import Page from 'src/components/Page';
import { contractService } from 'src/services';
import ExpiredSupply from '../components/ExpiredSupply';

const useStyles = makeStyles(theme => ({
	root: {
		height: '100%'
	},
	container: {
		height: '100%',
		paddingTop: theme.spacing(2)
	},
	section: {
		marginBottom: theme.spacing(2)
	}
}))

function Expired() {
	const classes = useStyles();
	const [dataSource, setDataSource] = useState([]);
	const [isLoading, setIsLoading] = useState(true);	

	const getData = useCallback(() => {
		setIsLoading(true);

		let params = {
			lines: true
		}

		contractService.getGroupedByPodPdr(params)
			.then(response => {
				let entity = response?.data?.results;

				 setDataSource(entity);
			})
			.catch(e => {
				console.error("errore", e);
			})
			.finally(() => setIsLoading(false));
	}, []);
		
	useEffect(() => {
		getData()
	}, [getData])

	return (
		<Page className={classes.root} title="Storico Forniture">
			<Container className={classes.container} maxWidth={false}>
				{!isLoading ? (
					<>
						{dataSource?.map(x => (
							<ExpiredSupply entity={x} key={x?.id} expanded />
						))}

						{dataSource.length === 0 && (
							<Box
								display="flex"
								alignItems="center"
								justifyContent="center"
								flexDirection="column"
								height="85%"
							>
								<Typography variant="subtitle2" color="textSecondary">
									Nessuna fornitura disponibile
								</Typography>
							</Box>
						)}
					</>
				) : (
					<Box
						display="flex"
						alignItems="center"
						justifyContent="center"
						flexDirection="column"
						height="85%"
					>
						<CircularProgress size={20} />
						&nbsp;
						<Typography variant="subtitle2" color="textSecondary">
							Caricamento in corso
						</Typography>
					</Box>
				)}
			</Container>
		</Page>
	);

}

export default Expired;